module.exports = __webpack_public_path__ + "img/inventory-filter.6a4b712c.png";